// extracted by mini-css-extract-plugin
export var cardIcon = "_63-5";
export var cardIconUnframed = "_63-9";
export var checkboxCard = "_63-0";
export var checkboxCardSelected = "_63-4";
export var disabled = "_63-2";
export var interactive = "_63-1";
export var outerBorder = "_63-3";
export var spacerMedium = "_63-8";
export var spacerSmall = "_63-7";
export var spacerXsmall = "_63-6";